/* eslint-disable */
/** @preserve
 * package: sweetalert2-react-content v1.1.0
 * file: dist/sweetalert2-react-content.cjs.js
 * homepage: https://github.com/sweetalert2/sweetalert2-react-content#readme
 * license: MIT
 * */

/**
 * This is an override shim for sweetalert2-react-content to support our use of
 * shared react root (and the Intl providers that come with it)
 *
 * This will likely break if you upgrade sweet-alert.  Instead, you should just
 * get rid of sweet-alert/VndlyAlert entirely. That would be a much better use
 * of your time.
 */

import React from 'react'
import { renderIntoSharedReactRoot } from '~/common/SharedReactRootManager'

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function')
  }
}

function _defineProperties(target, props) {
  for (let i = 0; i < props.length; i++) {
    const descriptor = props[i]
    descriptor.enumerable = descriptor.enumerable || false
    descriptor.configurable = true
    if ('value' in descriptor) descriptor.writable = true
    Object.defineProperty(target, descriptor.key, descriptor)
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps)
  if (staticProps) _defineProperties(Constructor, staticProps)
  return Constructor
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function')
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  })
  if (superClass) _setPrototypeOf(subClass, superClass)
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o)
      }
  return _getPrototypeOf(o)
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p
      return o
    }

  return _setPrototypeOf(o, p)
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
  }

  return self
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === 'object' || typeof call === 'function')) {
    return call
  }

  return _assertThisInitialized(self)
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object)
    if (object === null) break
  }

  return object
}

function _get(target, property, receiver) {
  if (typeof Reflect !== 'undefined' && Reflect.get) {
    _get = Reflect.get
  } else {
    _get = function _get(target, property, receiver) {
      const base = _superPropBase(target, property)

      if (!base) return
      const desc = Object.getOwnPropertyDescriptor(base, property)

      if (desc.get) {
        return desc.get.call(receiver)
      }

      return desc.value
    }
  }

  return _get(target, property, receiver || target)
}

const mounts = [
  {
    key: 'title',
    getter: function getter(swal) {
      return swal.getTitle()
    }
  },
  {
    key: 'html',
    getter: function getter(swal) {
      return swal.getContent()
    }
  },
  {
    key: 'confirmButtonText',
    getter: function getter(swal) {
      return swal.getConfirmButton()
    }
  },
  {
    key: 'cancelButtonText',
    getter: function getter(swal) {
      return swal.getCancelButton()
    }
  },
  {
    key: 'footer',
    getter: function getter(swal) {
      return swal.getFooter()
    }
  }
]

const noop = function noop() {}

const error = function error(message) {
  return new Error('sweetalert2-react-content: '.concat(message))
}

function withReactContent(ParentSwal) {
  return (
    /* #__PURE__ */
    (function (_ParentSwal) {
      _inherits(_class, _ParentSwal)

      function _class() {
        _classCallCheck(this, _class)

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments))
      }

      _createClass(
        _class,
        [
          {
            key: '_main',
            value: function _main(params) {
              const self = this
              params = { ...params }
              self.__roots = {}
              params.onOpen = params.onOpen || noop
              params.onClose = params.onClose || noop
              mounts.forEach(function (_ref) {
                const key = _ref.key
                const getter = _ref.getter

                if (React.isValidElement(params[key])) {
                  const reactElement = params[key]
                  params[key] = ' '
                  let domElement
                  const superOnOpen = params.onOpen

                  params.onOpen = function () {
                    // Customized stuff here for render into shared root
                    domElement = getter(ParentSwal)
                    self.__roots[key] = renderIntoSharedReactRoot(reactElement, domElement)
                    superOnOpen()
                  }

                  const superOnClose = params.onClose

                  params.onClose = function () {
                    superOnClose()
                    // more customized to clean up
                    self.__roots[key].unmount()
                    delete self.__roots[key]
                  }
                }
              })
              return _get(_getPrototypeOf(_class.prototype), '_main', this).call(this, params)
            }
          },
          {
            key: 'update',
            value: function update() {
              throw error(
                'Swal.update() is not yet supported. See https://github.com/sweetalert2/sweetalert2-react-content/issues/73'
              )
            }
          }
        ],
        [
          {
            key: 'argsToParams',
            value: function argsToParams(args) {
              if (React.isValidElement(args[0]) || React.isValidElement(args[1])) {
                const params = {}
                ;['title', 'html', 'type'].forEach(function (name, index) {
                  if (args[index] !== undefined) {
                    params[name] = args[index]
                  }
                })
                return params
              }
              // Upgrade text:react to html:react
              if (args.length === 1 && args[0]?.text && React.isValidElement(args[0]?.text)) {
                return  {...args[0], html: args[0].text}
              }
              // Fallback
              return ParentSwal.argsToParams(args)

            }
          }
        ]
      )

      return _class
    })(ParentSwal)
  )
}

export default withReactContent
